package components

import androidx.compose.runtime.Composable
import business.CampaignConfig
import format.formatRub
import form.FieldError
import form.calculatorFieldDefinitions
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLInputElement

@Composable
fun ReferralDiscountPanel(
    baseCardCostValue: String,
    cardCostError: FieldError?,
    effectiveCardCostRub: Double?,
    campaignConfig: CampaignConfig,
    codeVisible: Boolean,
    referralDiscountEnabled: Boolean,
    onBaseCardCostChange: (String) -> Unit,
    onRevealCode: () -> Unit,
    onDiscountEnabledChange: (Boolean) -> Unit,
) {
    val cardCostField = calculatorFieldDefinitions.single { it.key == "apecCardCostRub" }

    Div({ classes("panel", "referral-discount-panel") }) {
        H2 { Text("Цена карты АТЭС") }
        NumberField(
            label = "Базовая цена карты",
            suffix = cardCostField.suffix,
            helpText = "Введите цену, которую хотите сравнить с визаранами.",
            currentValue = baseCardCostValue,
            error = cardCostError?.message,
            onChange = onBaseCardCostChange,
        )
        if (!codeVisible) {
            Button({
                classes("primary-button", "full-width-button")
                onClick { onRevealCode() }
            }) {
                Text("Показать скидку в расчете")
            }
        } else {
            Div({ classes("ref-code") }) { Text(campaignConfig.referralCode) }
            Label(attrs = { classes("discount-toggle") }) {
                Input(InputType.Checkbox) {
                    if (referralDiscountEnabled) attr("checked", "")
                    attr("aria-label", "Применить REF-скидку")
                    onChange { event ->
                        onDiscountEnabledChange(event.target.unsafeCast<HTMLInputElement>().checked)
                    }
                }
                Span { Text("Применить REF-скидку ${formatRub(campaignConfig.referralDiscountRub)}") }
            }
            effectiveCardCostRub?.let { cost ->
                P({ classes("field-help") }) {
                    Text("Расчетная цена карты: ${formatRub(cost)}. Назовите код менеджеру при обращении.")
                }
            }
        }
    }
}
